<template>
    <SectionLayout v-if="renderComponent" 
        class="insurance-process-section" 
            :title="sectionTitle" 
            bg-theme="primary-invert" 
            ref="sectionRef">
        <InsuranceTariffsList v-show="step === 1" 
            @tariff-chosen="handleTariff"
            @cancel-subscription="showModalSubsciptionCancel = true" />
        <InsuranceExecution v-show="step === 2" 
            :tariff="chosenTariff"
            @cancel-subscription="showModalSubsciptionCancel = true" 
            @payment-link-sent="onPaymentLinkSent"
            @close="onClose" />

        <ModalSubscriptionCancel v-if="showModalSubsciptionCancel" 
            :visible="showModalSubsciptionCancel" 
            modal-width="643px"
            @close="closeCancelModal" />

        <ModalPaymentLinkWasSent v-if="showModalPaymentLinkWasSent" 
            :visible="showModalPaymentLinkWasSent"
            modal-width="643px" 
            @close="showModalPaymentLinkWasSent = false" />
    </SectionLayout>
</template>

<script>
import SectionLayout from '@/components/layouts/SectionLayout';
import InsuranceTariffsList from '@/components/pages/index/InsuranceProcess/InsuranceTariffsList';
import InsuranceExecution from '@/components/pages/index/InsuranceProcess/InsuranceExecution';
import ModalSubscriptionCancel from '@/components/modals/ModalSubscriptionCancel';
import ModalPaymentLinkWasSent from '@/components/modals/ModalPaymentLinkWasSent';

export default {
    name: 'InsuranceProcess',
    components: {
        SectionLayout,
        InsuranceTariffsList,
        InsuranceExecution,
        ModalSubscriptionCancel,
        ModalPaymentLinkWasSent
    },
    data() {
        return {
            renderComponent: true,
            step: 1,
            chosenTariff: '',
            showModalSubsciptionCancel: false,
            showModalPaymentLinkWasSent: false
        }
    },
    props: [
        'showModalSubsciptionCancel',
    ],
    methods: {
        closeCancelModal()
        {
            this.showModalSubsciptionCancel = false;
            this.$emit('close-cancel-modal');
        },
        handleTariff(tariff) {
            this.chosenTariff = tariff;
            this.step++;

            this.scrollToSectionTop();
        },
        onPaymentLinkSent() {
            this.resetComponent();
            this.showModalPaymentLinkWasSent = true;
        },
        async resetComponent() {
            this.renderComponent = false;
            await this.$nextTick();
            this.renderComponent = true;
        },
        onClose() {
            this.step = 1;
            this.scrollToSectionTop();
        },
        scrollToSectionTop() {
            if (this.$refs?.sectionRef?.$el) {
                this.$refs.sectionRef.$el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
        }
    },
    computed: {
        sectionTitle() {
            switch (this.step) {
                case 1:
                    return 'Выберите вариант страхования';
                case 2:
                    return 'Страхование имущества юридического лица';
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.insurance-process-section {}
</style>